import { useDispatch, useSelector } from 'react-redux'
import { setActiveTab } from '../../../store/userSearchProfile'
import { useFirefly } from '../../../resources/useAnalytics'

export const useSearchHeader = () => {
  const dispatch = useDispatch()
  const { handleTrackEvent } = useFirefly()

  const activeTab = useSelector((state) => {
    return state.userSearchProfile.searchHeader.activeTab
  })
  const onTabSelect = (event, tab) => {
    dispatch(setActiveTab(tab.name))
    handleTrackEvent('Sticker Tab', event)
  }

  return {
    activeTab,
    onTabSelect,
  }
}
